
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_17004","data-name":"Rectangle 17004","width":"16","height":"16","fill":"#fff"}})])]),_c('g',{attrs:{"id":"Group_49600","data-name":"Group 49600","transform":"translate(-239 -326)"}},[_c('rect',{attrs:{"id":"Rectangle_17003","data-name":"Rectangle 17003","width":"24","height":"24","rx":"6","transform":"translate(239 326)","fill":"#6762f0"}}),_c('g',{attrs:{"id":"Group_49587","data-name":"Group 49587","transform":"translate(243.379 330.378)"}},[_c('g',{attrs:{"id":"Group_49586","data-name":"Group 49586","transform":"translate(-.378 -.378)","clip-path":"url(#clip-path)","fill":"#fff"}},[_c('path',{attrs:{"id":"Path_38941","data-name":"Path 38941","d":"M12.3 1.295h-.647V.647a.647.647 0 10-1.295 0v.647h-5.18V.647a.647.647 0 10-1.295 0v.647h-.647A3.24 3.24 0 000 4.531V12.3a3.24 3.24 0 003.236 3.236h2.589a.647.647 0 000-1.295H3.236A1.944 1.944 0 011.295 12.3V6.473h13.592a.648.648 0 00.647-.647V4.531A3.24 3.24 0 0012.3 1.295m1.94 3.883H1.295v-.647a1.944 1.944 0 011.941-1.942H12.3a1.944 1.944 0 011.94 1.942z","transform":"translate(.233 .233)"}}),_c('path',{attrs:{"id":"Path_38942","data-name":"Path 38942","d":"M342.628 316.937v-1.027a.647.647 0 00-1.295 0v1.29a.647.647 0 00.19.458l.647.647a.647.647 0 10.915-.915z","transform":"translate(-330.744 -305.465)"}}),_c('path',{attrs:{"id":"Path_38943","data-name":"Path 38943","d":"M234.01 247.357a4.015 4.015 0 104.026 4 4.03 4.03 0 00-4.026-4m0 6.816a2.8 2.8 0 112.812-2.812 2.8 2.8 0 01-2.812 2.812","transform":"translate(-222.773 -239.619)"}})])])])])
          )
        }
      }
    